"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializerService = void 0;
var ClassTransformer = __importStar(require("class-transformer"));
var SerializerService = /** @class */ (function () {
    function SerializerService() {
    }
    SerializerService.classTransformOptions = {
        excludeExtraneousValues: true,
        exposeDefaultValues: true,
        strategy: 'excludeAll',
    };
    SerializerService.plainToClass = function (model, payload) {
        return ClassTransformer.plainToInstance(model, payload, SerializerService.classTransformOptions);
    };
    SerializerService.stripNullableProperties = function (model) {
        return Object.fromEntries(Object.entries(model).filter(function (_a) {
            var value = _a[1];
            return value !== null;
        }));
    };
    SerializerService.classToPlain = function (model) {
        return ClassTransformer.instanceToPlain(model);
    };
    SerializerService.toJSONString = function (model) {
        return JSON.stringify(SerializerService.classToPlain(model));
    };
    return SerializerService;
}());
exports.SerializerService = SerializerService;
